<template>
	<header class="px-2 py-3">
		<div class="container-fluid">

			<div class="row">

				<div class="col">
					<div class="d-flex justify-content-start no-select">
						<ol class="breadcrumb mb-0 chip">
							<li class="breadcrumb-item" :class="{ active: isHome }">
								<router-link :to="'/'" :is="isHome ? 'span' : 'router-link'">
									<b>{{ $t('product_title') }}</b>
								</router-link>
							</li>

							<li v-if="currentModule" class="breadcrumb-item" :class="{ 'active': isModule }">
								<router-link :to="'/' + currentModule" :is="isModule ? 'span' : 'router-link'">
									<b>{{ $t('module') + ' ' + routeToNumber(this.currentModule) }}</b>
								</router-link>
							</li>

							<li v-if="currentTask" class="breadcrumb-item active">
								<span>
									<b>{{ currentTaskNumber }}</b>
								</span>
							</li>

							<!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> -->
						</ol>
					</div>
				</div>

				<div class="col-auto d-none d-ratio justify-content-center no-select">
					<div v-if="currentTask" class="text-center d-flex flex-column">
						<!-- <span>{{ getText(routeToId(currentModule), 'title') }}</span> -->
						<ol class="breadcrumb mb-0 mx-auto chip">
							<li v-if="$tracker.debug" class="breadcrumb-item" :class="{ active: !prevTask }">
								<router-link
									class="px-2"
									:to="prevTask"
									:is="!prevTask ? 'span' : 'router-link'">
									Prev
								</router-link>
							</li>
							<li class="breadcrumb-item">
								<span class="fw-bold invert px-2">
									{{ currentTaskTitle }}
								</span>
							</li>
							<li v-if="$tracker.debug" class="breadcrumb-item" :class="{ active: !nextTask }">
								<router-link
									class="px-2"
									:to="nextTask"
									:is="!nextTask ? 'span' : 'router-link'">
									Next
								</router-link>
							</li>
						</ol>
					</div>
				</div>

				<div class="col">
					<div class="d-flex justify-content-end">
						<span v-if="$tracker.debug && classroomCode" class="chip chip-hover pointer me-3" @click="$emit('openModalDifficulty')">
							<!-- {{ getText('classroom_short') }}: <b>{{ classroomCode }}</b> -->
							<b-icon class="chip-icon" :icon="difficultyIcon"></b-icon>
							<b>{{ difficultyText }}</b>
						</span>
						<span v-if="classroomCode" class="chip chip-hover pointer me-3" @click="$emit('openModalCode')">
							<!-- {{ getText('classroom_short') }}: <b>{{ classroomCode }}</b> -->
							<b-icon class="chip-icon" icon="house-fill"></b-icon>
							<b>{{ classroomCode }}</b>
						</span>
						<span v-if="sessionCode" class="chip chip-hover pointer me-2" @click="$emit('openModalCode')">
							<!-- {{ getText('session_short') }}: <b>{{ sessionCode }}</b> -->
							<b-icon class="chip-icon" icon="person-fill"></b-icon>
							<b>{{ sessionCode }}</b>
						</span>
						<LocaleSwitcher />
					</div>
				</div>

			</div>
		</div>

		<div v-if="$tracker.debug && currentTask" class="overlay">
			<p>
				Task: <b>{{ routeId }}</b>
			</p>
			<p>
				Performance: <b>{{ $tracker.performance }}</b>
			</p>
			<p>
				Mistakes (M = <b>{{ mistakeMean }}</b>, SD = <b>{{ mistakeSd }}</b>)
			</p>
			<p>
				Duration (M = <b>{{ durationMean }}</b>s, SD = <b>{{ durationSd }}</b>s)
			</p>
		</div>
	</header>
</template>



<script>
import LocaleSwitcher from "@/components/LocaleSwitcher";
import taskNormals from "@/assets/normals.json"

export default {
	props: [],
	components: { LocaleSwitcher },
	data() {
		return {
			sessionCode: null,
			classroomCode: null,
			currentModule: null,
			currentTask: null,
			tasks: [],

			forceUpdate: 0,

			// Debug
			// tracker: {
				// behavior: null,
				// currentTask: null,
				// time: null,
			// }
			taskNormals: taskNormals
		};
	},
	mounted() {
		this.setRoute(this.$route);

		this.$log.init();
		this.$log.onPageRoute(this.$route.name, this.$route.path);
		// setInterval(this.updateDebug.bind(this), 500);

		// this.fetch(`/api/get_modules/`, data => {
		// 	if (data) {
		// 		this.tasks = [];
		// 		for (let mod of data) {
		// 			for (let task of mod.tasks) {
		// 				this.tasks.push({ module: mod.name, task: task });
		// 			}
		// 		}
		// 	}
		// });

		this.onSessionLoad();

		window.addEventListener("onChangeBehavior", this.onChangeBehavior, false);
	},

	methods: {
		onSessionLoad() {
			this.classroomCode = this.$tracker.classroom;
			this.sessionCode = this.$tracker.session;

			if (this.$tracker.modules.length > 0) {
				this.tasks = [];
				for (let mod of this.$tracker.modules) {
					for (let task of mod.tasks) {
						this.tasks.push({ module: mod.name, task: task });
					}
				}
			}
		},

		onChangeBehavior() {
			this.forceUpdate++;
		},

		setRoute(route) {
			this.currentModule = route.params.moduleName;
			this.currentTask = route.params.taskName;
		},

		// updateDebug() {
			// this.$set(this.tracker, "behavior", this.$tracker.behavior);
			// this.$set(this.tracker, "currentTask", this.$tracker.currentTask);
			// this.$set(this.tracker, "time", this.$tracker.time);
		// }
	},
	computed: {
		isHome() {
			return !this.currentModule;
		},
		isModule() {
			return this.currentModule && !this.currentTask;
		},
		isTask() {
			return !!this.currentTask;
		},

		nextTask() {
			let index = this.tasks.findIndex(t => (this.currentModule == t.module && this.currentTask == t.task));
			if (index+1 < this.tasks.length) {
				const next = this.tasks[index+1];
				return '/' + next.module + '/' + next.task;
			}
			return null;
		},
		prevTask() {
			let index = this.tasks.findIndex(t => (this.currentModule == t.module && this.currentTask == t.task));
			if (index-1 >= 0) {
				const prev = this.tasks[index-1];
				return '/' + prev.module + '/' + prev.task;
			}
			return null;
		},

		currentTaskTitle() {
			if (this.currentTask.startsWith('task')) {
				return this.getText(this.routeToId(this.currentModule, this.currentTask), 'title');
			}
			else {
				return this.currentTaskNumber;
			}
		},

		currentTaskNumber() {
			if (this.currentTask.startsWith('task')) {
				return this.$t('task') + ' ' + this.routeToNumber(this.currentTask);
			}
			else {
				return this.$t('quiz') + ' ' + this.routeToNumber(this.currentTask);
			}
		},

		// currentModuleName() {
			// return getText(routeToId(currentModule), 'title');
		// },
		// currentTaskName() {
			// return getText(routeToId(currentModule, currentTask), 'title');
		// }

		difficultyText() {
			if (this.forceUpdate != this.forceUpdate) {
				return "";
			}

			if (this.$tracker.isEasy()) {
				return "EASY";
			}
			else if (this.$tracker.isHard()) {
				return "HARD";
			}
			else {
				return "MEDIUM";
			}
		},
		difficultyIcon() {
			if (this.forceUpdate != this.forceUpdate) {
				return "";
			}

			if (this.$tracker.behavior == "ADAPTIVE") {
				if (this.$tracker.isEasy()) {
					return "thermometer-low";
				}
				else if (this.$tracker.isHard()) {
					return "thermometer-high";
				}
				else {
					return "thermometer-half";
				}
			}
			else if (this.$tracker.behavior == "RANDOM") {
				return "shuffle";
			}
			else {
				return "lock-fill";
			}
		},

		routeId() {
			this.forceUpdate++;
			if (this.currentModule && this.currentTask) {
				return this.routeToId(this.currentModule, this.currentTask);
			}
			return "";
		},
		difficulty() {
			if (this.forceUpdate != this.forceUpdate) {
				return "";
			}
			if (this.$tracker.performance <= 30) {
				return "easy";
			}
			if (this.$tracker.performance >= 70) {
				return "hard";
			}
			return "medium";
		},
		mistakeMean() {
			const mean = taskNormals.task_mistake_mean_map[this.routeId];
			if (mean) {
				return mean[this.difficulty];
			}
			return 0;
		},
		mistakeSd() {
			const sd = taskNormals.task_mistake_sd_map[this.routeId];
			if (sd) {
				return sd[this.difficulty];
			}
			return 0;
		},
		durationMean() {
			const mean = taskNormals.task_duration_mean_map[this.routeId];
			if (mean) {
				return mean[this.difficulty];
			}
			return 0;
		},
		durationSd() {
			const sd = taskNormals.task_duration_sd_map[this.routeId];
			if (sd) {
				return sd[this.difficulty];
			}
			return 0;
		},
	},
	watch: {
		$route (newRoute) {
			this.$log.onPageRoute(newRoute.name, newRoute.path);
			this.setRoute(newRoute);
		}
	}
};
</script>



<style scoped>
	header {
		z-index: 10;
/*		height: 5.68vh;*/
/*		max-height: 5.68vh;*/
		/*overflow: hidden;*/
		position: absolute;
		width: 100%;
		/*filter: invert(100%);*/
		/*backdrop-filter: blur(5px);*/
		font-size: 1.5vmin;
	}

	@media (min-aspect-ratio: 4/3) {
		.d-ratio {
			display: flex !important;
		}
	}

	.py-3 {
		padding-top: 1.5vmin !important;
		padding-bottom: 1.5vmin !important;
	}
	.px-2 {
		padding-right: 0.75vmin !important;
		padding-left: 0.75vmin !important;
	}
	.row {
	}

	.breadcrumb-item {
		padding-left: 0.75vmin !important;
	}
	.breadcrumb-item + .breadcrumb-item::before {
		padding-right: 0.75vmin;
	}
	.breadcrumb > li + li:before {
		/*content: "\0203A";*/
		/*content: "/";*/
		content: "/";
		/*content: "♥";*/
	}

	.chip {
		/*background-color: var(--bs-gray-300);*/
		border-radius: 100em;
		padding: .25em .75em .25em .6em;
		padding: .37vmin 1.1vmin .37vmin .9vmin;
		margin: -.25em 0;
		margin: -.37vmin 0;
/*		background-color: var(--bs-light);*/
		background-color: #f8f9faaa;
		backdrop-filter: blur(5px);
		color: var(--bs-dark);
/*		box-shadow: 1px 1px 4px rgba(0,0,0,.1);*/

		flex-wrap: nowrap;
		white-space: nowrap;
	}
	.chip-hover:hover {
		background-color: var(--bs-warning);
	}

	.chip-icon {
		margin-right: .5em;
		margin-right: .75vmin;
	}

	.invert {
/*		mix-blend-mode: difference;*/
	}

	a {
/*		filter: invert(100%);*/
/*		color: var(--bs-warning);*/
		text-decoration: none;
	}

	.overlay {
		position: absolute;
		right: 0;
		float: right;
		background-color: #d9f1ff77;
		backdrop-filter: blur(5px);
		margin: .7vw 1vw 0 0;
		padding: 8px;
	}

	.overlay p {
		margin: 0;
	}
</style>
